import axios from "axios";
import { toastError } from "../Components/ToastNotification";

axios.interceptors.response.use(null, (error) => {
  const unexpectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!unexpectedError) {
    toastError("No Network,Check connection...");
  }
  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.patch,
  update: axios.put,
  delete: axios.delete,
};
